const dotToArrayPath = path => {
  const re = /\.(\d+)/g;
  return path.replace(re, (match, p1) => `[${p1}]`)
}
const handleErrors = (e, setErrors) => {
  let displayMessage = ''

  const data = e?.response?.data
  if (data) {
    const {errors, message} = data
    if (typeof errors === 'object' && Object.keys(errors).length) {
      const parsedErrors = []
      console.error(errors)
      for (const key in errors) {
        parsedErrors.push({name: dotToArrayPath(key), message: errors[key]})
        displayMessage += errors[key]
      }
      if (setErrors) {
        if (errors?._error) {
          setErrors(errors)
          return errors._error;
        }
        setErrors(errors)
      }
    }

    // displayMessage = displayMessage || data.displayMessage || message
    displayMessage = message
  }

  const message = displayMessage || 'An error has occured. Please try again.'
  // toast.error(message, {autoClose: time})
  return message;
}

export default handleErrors;